var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.41602H15.625C15.9702 9.41602 16.25 9.13619 16.25 8.79102C16.25 8.44584 15.9702 8.16602 15.625 8.16602H9.375C9.02982 8.16602 8.75 8.44584 8.75 8.79102C8.75 9.13619 9.02982 9.41602 9.375 9.41602Z",
    fill: "#AC98F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.29102H18.125C18.4702 6.29102 18.75 6.01119 18.75 5.66602C18.75 5.32084 18.4702 5.04102 18.125 5.04102H9.375C9.02982 5.04102 8.75 5.32084 8.75 5.66602C8.75 6.01119 9.02982 6.29102 9.375 6.29102Z",
    fill: "#AC98F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15.666H10.625C10.9702 15.666 11.25 15.3862 11.25 15.041C11.25 14.6958 10.9702 14.416 10.625 14.416H9.375C9.02982 14.416 8.75 14.6958 8.75 15.041C8.75 15.3862 9.02982 15.666 9.375 15.666Z",
    fill: "#AC98F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.541H13.125C13.4702 12.541 13.75 12.2612 13.75 11.916C13.75 11.5708 13.4702 11.291 13.125 11.291H9.375C9.02982 11.291 8.75 11.5708 8.75 11.916C8.75 12.2612 9.02982 12.541 9.375 12.541Z",
    fill: "#AC98F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10374 12.9099C2.00997 12.8194 1.88261 12.7683 1.75 12.7683C1.61739 12.7683 1.49021 12.8192 1.39645 12.9097L1.39218 12.9139C1.3012 13.0041 1.25 13.1253 1.25 13.2512L1.25001 13.2539C1.25074 13.3811 1.30336 13.5028 1.39645 13.5927L3.39645 15.5246C3.49022 15.6151 3.61739 15.666 3.75 15.666C3.88261 15.666 4.00979 15.6151 4.10355 15.5246L6.10355 13.5927C6.19732 13.5022 6.25 13.3793 6.25 13.2512C6.25 13.2429 6.24978 13.2346 6.24933 13.2263C6.24293 13.107 6.191 12.9942 6.10355 12.9097C6.00979 12.8192 5.88261 12.7683 5.75 12.7683C5.61739 12.7683 5.49022 12.8192 5.39645 12.9097L3.75 14.5001L2.10374 12.9099Z",
    fill: "#AC98F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.52397V15.1831C3.25 15.4498 3.47386 15.666 3.75 15.666C4.02614 15.666 4.25 15.4498 4.25 15.1831V5.52397C4.25 5.25724 4.02614 5.04102 3.75 5.04102C3.47386 5.04102 3.25 5.25724 3.25 5.52397Z",
    fill: "#AC98F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.005725101f332e64f2b0c17c1e861344.svg";
export { ForwardRef as ReactComponent };